var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('p',{staticClass:"title"},[_vm._v("POSTAGENS ANÔNIMAS")]),_c('b-row',{attrs:{"align-h":"start"}},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12"}},[_c('Tabela')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }